// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title_3D0OF","description":"Documents_description_1zVyG"};